module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperLinen-41288ffab0656ca0968d4cb4e6e26fad.jpg";